import React from 'react';

interface PropsShape {
    crumbs: string[];
    onClickBreadCrumb: (crumb: string, index: string) => void;
    disableParentPath?: boolean;
}

const BreadCrumb = (props: PropsShape) => (
    <nav>
        <ol className="breadcrumb">
            {props.crumbs.map((crumb: any, ci: any) => {
                return (
                    <React.Fragment key={ci}>
                        <li key={ci}>
                            <button
                                data-key={ci}
                                data-testid={'crumb'}
                                className={`btn btn-link`}
                                disabled={ci === 0 && props.disableParentPath}
                                onClick={(e: any) => {
                                    return props.onClickBreadCrumb(
                                        crumb,
                                        e.target.getAttribute('data-key')
                                    );
                                }}
                            >
                                {crumb}
                            </button>
                        </li>
                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </React.Fragment>
                );
            })}
        </ol>
    </nav>
);

export default BreadCrumb;
